import { useI18n } from "../../util/i18n";
import React, { useEffect, useState } from "react";
import panelApi from "../../util/panelApi";
import { NavLink, useHistory, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { LOGOUT_ADMIN } from "../../store/Admin/admin.type";
import { warning } from "../../util/Alert";
import logo from "../../assets/img/logo.png";

//css
import "../../assets/css/bootstrap.min.css";
import "../../assets/css/plugins.css";
import "../../assets/css/structure.css";

//js
import "../../assets/js/bootstrap/js/bootstrap.min.js";
import "../../assets/js/bootstrap/js/popper.min.js";
import "../../assets/js/custom";

/// Oturumdaki yoneticinin rolu (token icinden). Sunucu ayrica her istekte kontrol eder.
export const currentRole = () => {
  try {
    const t = sessionStorage.getItem("token") || "";
    const p = JSON.parse(decodeURIComponent(escape(atob(t.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")))));
    return p.role || "owner";
  } catch (e) {
    return "owner";
  }
};

export const ROLE_LABEL = { owner: "Sahip", manager: "Super Admin", agency_rep: "Ajans sorumlusu", moderator: "Moderatör", finance: "Finans" };

const I = (d) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    {d}
  </svg>
);
const ic = {
  dash: I(<><rect x="3" y="3" width="7" height="9" rx="1" /><rect x="14" y="3" width="7" height="5" rx="1" /><rect x="14" y="12" width="7" height="9" rx="1" /><rect x="3" y="16" width="7" height="5" rx="1" /></>),
  users: I(<><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" /></>),
  mic: I(<><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" /><path d="M19 10v2a7 7 0 0 1-14 0v-2M12 19v4" /></>),
  building: I(<><rect x="4" y="2" width="16" height="20" rx="2" /><path d="M9 22v-4h6v4M8 6h.01M16 6h.01M12 6h.01M12 10h.01M12 14h.01M16 10h.01M16 14h.01M8 10h.01M8 14h.01" /></>),
  live: I(<><path d="M23 7l-7 5 7 5V7z" /><rect x="1" y="5" width="15" height="14" rx="2" /></>),
  room: I(<><path d="M3 18v-6a9 9 0 0 1 18 0v6" /><path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z" /></>),
  flag: I(<><path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" /><path d="M4 22v-7" /></>),
  image: I(<><rect x="3" y="3" width="18" height="18" rx="2" /><circle cx="8.5" cy="8.5" r="1.5" /><path d="M21 15l-5-5L5 21" /></>),
  shield: I(<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />),
  gem: I(<><path d="M6 3h12l4 6-10 13L2 9z" /><path d="M11 3 8 9l4 13 4-13-3-6M2 9h20" /></>),
  gift: I(<><rect x="3" y="8" width="18" height="4" rx="1" /><path d="M12 8v13M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7M7.5 8a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8s1-5 4.5-5a2.5 2.5 0 0 1 0 5" /></>),
  wallet: I(<><path d="M20 12V8H6a2 2 0 0 1 0-4h12v4" /><path d="M4 6v12a2 2 0 0 0 2 2h14v-4" /><path d="M18 12a2 2 0 0 0 0 4h4v-4z" /></>),
  coin: I(<><ellipse cx="12" cy="6" rx="8" ry="3" /><path d="M4 6v6c0 1.66 3.58 3 8 3s8-1.34 8-3V6M4 12v6c0 1.66 3.58 3 8 3s8-1.34 8-3v-6" /></>),
  star: I(<polygon points="12 2 15 8.5 22 9.3 17 14 18.2 21 12 17.8 5.8 21 7 14 2 9.3 9 8.5 12 2" />),
  game: I(<><rect x="2" y="6" width="20" height="12" rx="3" /><path d="M6 12h4M8 10v4M15 11h.01M18 13h.01" /></>),
  chat: I(<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />),
  team: I(<><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 11l-3 3-2-2" /></>),
  send: I(<><path d="M22 2 11 13" /><path d="M22 2 15 22l-4-9-9-4z" /></>),
  settings: I(<><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-2.82 1.18V21a2 2 0 1 1-4 0v-.09a1.65 1.65 0 0 0-2.82-1.18l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 3 15.4 1.65 1.65 0 0 0 1.5 14H1.4a2 2 0 1 1 0-4h.1A1.65 1.65 0 0 0 3 8.6a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 8.6 3h.1A1.65 1.65 0 0 0 10 1.5V1.4a2 2 0 1 1 4 0v.1A1.65 1.65 0 0 0 15.4 3a1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 21 8.6V9a1.65 1.65 0 0 0 1.5 1.4h.1a2 2 0 1 1 0 4h-.1A1.65 1.65 0 0 0 19.4 15z" /></>),
  logs: I(<><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><path d="M14 2v6h6M16 13H8M16 17H8M10 9H8" /></>),
  logout: I(<><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><polyline points="16 17 21 12 16 7" /><line x1="21" y1="12" x2="9" y2="12" /></>),
};

/// Menu: grup · baslik · adres · alt sayfalar · gorebilen roller (bos = sadece sahip)
const MENU = [
  { group: "Genel", items: [
    { label: "Panel", to: "/admin/dashboard", icon: "dash", roles: ["manager", "moderator", "finance"] },
    { label: "Kullanıcılar", to: "/admin/user", icon: "users" },
    { label: "Yayıncılar", icon: "mic", children: [
      { label: "Gerçek yayıncılar", to: "/admin/host" },
      { label: "Yayıncı başvuruları", to: "/admin/hostRequest" },
      { label: "Vitrin hesapları", to: "/admin/fakeHost", gift: true },
      { label: "Vitrin hikâyeleri", to: "/admin/fakeStory", gift: true },
    ] },
    { label: "Ajanslar", to: "/admin/agencies", icon: "building", roles: ["manager", "agency_rep"] },
    { label: "Hedef takibi", to: "/admin/agencyTargets", icon: "star", roles: ["manager", "agency_rep"] },
    { label: "Seviye Yönetimi", to: "/admin/levels", icon: "star" },
  ] },
  { group: "Canlı", items: [
    { label: "Canlı yayınlar", to: "/admin/liveStreams", icon: "live", roles: ["moderator", "manager"] },
    { label: "Sesli odalar", to: "/admin/voiceRooms", icon: "room", roles: ["moderator", "manager"] },
    { label: "Yönetim odaları", to: "/admin/officialRooms", icon: "room" },
    { label: "PK düelloları", to: "/admin/pkBattles", icon: "game", roles: ["moderator", "manager"] },
    { label: "Oyunlar", to: "/admin/games", icon: "game" },
    { label: "Anlar", to: "/admin/moments", icon: "image", roles: ["moderator", "manager"] },
    { label: "Mesaj merkezi", to: "/admin/inbox", icon: "chat" },
  ] },
  { group: "Güvenlik", items: [
    { label: "Şikayet kuyruğu", to: "/admin/complaintQueue", icon: "flag", roles: ["moderator", "manager"] },
    { label: "Eski şikayetler", icon: "flag", roles: ["moderator", "manager"], children: [
      { label: "Bekleyen", to: "/admin/pendingComplaint" },
      { label: "Çözülen", to: "/admin/solvedComplaint" },
    ] },
    { label: "Engellenenler", to: "/admin/bannedAccounts", icon: "shield", roles: ["moderator", "manager"] },
    { label: "Yasaklı kelimeler", to: "/admin/bannedWords", icon: "shield", roles: ["moderator", "manager"] },
    { label: "Güvenlik listeleri", to: "/admin/safety", icon: "shield", roles: ["moderator"] },
  ] },
  { group: "Uygulama", items: [
    { label: "Güncelleme duyurusu", to: "/admin/appVersion", icon: "send" },
    { label: "Açılış reklamı", to: "/admin/splashAds", icon: "gift" },
  ] },
  { group: "Gelir", items: [
    { label: "Hesaplar (kime ne ödenecek)", to: "/admin/accounts", icon: "wallet" },
    { label: "Ekonomi & VIP", to: "/admin/economy", icon: "gem" },
    { label: "Hediyeler", icon: "gift", children: [
      { label: "Kategoriler", to: "/admin/giftCategory", gift: true },
      { label: "Tüm hediyeler", to: "/admin/gift", gift: true },
    ] },
    { label: "Mağaza & Yüzükler", to: "/admin/storeRings", icon: "gift" },
    { label: "Kabile & Evlilik", to: "/admin/social", icon: "users" },
    { label: "Coin paketleri", icon: "coin", children: [
      { label: "Paketler", to: "/admin/coinPlan", gift: true },
      { label: "Satın alımlar", to: "/admin/purchasePlan", gift: true },
    ] },
    { label: "Yetkili Bayi", to: "/admin/coinBank", icon: "coin", roles: ["finance"] },
    { label: "Sözleşmeler", to: "/admin/contracts", icon: "shield" },
    { label: "Özel Çerçeve", to: "/admin/customFrames", icon: "image" },
    { label: "SVIP Ver", to: "/admin/svipGrant", icon: "gem" },
    { label: "Seviye Rozetleri", to: "/admin/levelBadges", icon: "gem" },
    { label: "Yüz Doğrulama", to: "/admin/faceVerify", icon: "gem" },
    { label: "Otomatik Bildirim", to: "/admin/autoPush", icon: "send" },
    { label: "Otomatik Selam", to: "/admin/autoGreet", icon: "send" },
    { label: "Maaş Politikası", to: "/admin/salaryPolicy", icon: "wallet" },
    { label: "Web Sitesi", to: "/admin/webSite", icon: "coin" },
    { label: "PK Turnuvası", to: "/admin/pkTournament", icon: "gift" },
    { label: "Para akışı", to: "/admin/moneyLogs", icon: "wallet", roles: ["finance"] },
    { label: "Coin dökümü", to: "/admin/coinFlow", icon: "coin", roles: ["finance"] },
    { label: "Çift hesaplar", to: "/admin/duplicates", icon: "users", roles: ["finance"] },
    { label: "Kâr / Zarar", to: "/admin/karZarar", icon: "wallet" },
    { label: "Uyarılar / İadeler", to: "/admin/uyarilar", icon: "send", roles: ["manager", "moderator", "finance", "agency_rep"] },
    { label: "Rol yetkileri", to: "/admin/rolYetki", icon: "users" },
    { label: "İnceleme (mesaj / 1v1 / transfer)", to: "/admin/inceleme", icon: "users", roles: ["manager", "moderator", "finance", "agency_rep"] },
    { label: "Kasa", to: "/admin/vault", icon: "wallet", roles: ["finance"], badge: "toplam" },
    { label: "Çekim talepleri", icon: "wallet", roles: ["finance"], children: [
      { label: "Bekleyen", to: "/admin/pendingRedeem" },
      { label: "Onaylanan", to: "/admin/acceptedRedeem" },
      { label: "Reddedilen", to: "/admin/declinedRedeem" },
      { label: "Ödeme yöntemleri", to: "/admin/withdraw" },
    ] },
  ] },
  { group: "AYVO Games", items: [
    { label: "AYVO Games", to: "/admin/ayvoGames", icon: "game" },
    { label: "AYVO Ludo – Agora", to: "/admin/ayvoLudoAgora", icon: "game" },
  ] },
  { group: "Ekip", items: [
    { label: "Paket gönder", to: "/admin/sendPackage", icon: "send", roles: ["manager", "agency_rep", "moderator", "finance"] },
    { label: "Personel & Paketler", to: "/admin/staff", icon: "team" },
    { label: "İşlem günlüğü", to: "/admin/adminLogs", icon: "logs" },
  ] },
  { group: "Ayarlar", items: [
    { label: "Afiş", to: "/admin/banner", icon: "image" },
    { label: "Çıkartma", to: "/admin/sticker", icon: "image" },
    // eski "Genel ayarlar" sayfasi kaldirildi; tum ayarlar tek sayfada
    { label: "BD", to: "/admin/bd", icon: "building" },
    { label: "Aylık Kart", to: "/admin/monthlyCard", icon: "wallet" },
    { label: "Sohbet Çevirisi", to: "/admin/translate", icon: "settings" },
    { label: "Görev Merkezi", to: "/admin/tasks", icon: "logs" },
    { label: "Davet Kodu", to: "/admin/invite", icon: "users" },
    { label: "Fan Kulübü", to: "/admin/fanClub", icon: "users" },
    { label: "Koruma", to: "/admin/guardian", icon: "shield" },
    { label: "VIP Üyeler", to: "/admin/vipMembers", icon: "users", roles: ["manager"] },
    { label: "Cihaz / IP yasağı", to: "/admin/bans", icon: "shield", roles: ["manager", "moderator"] },
    { label: "Uygulama ayarları", to: "/admin/appSetting", icon: "settings" },
    { label: "Profilim", to: "/admin/profile", icon: "users", roles: ["manager", "agency_rep", "moderator", "finance"] },
  ] },
];

export const canSee = (role, item) => role === "owner" || (item.roles || []).includes(role);

const Sidebar = () => {
  const { t } = useI18n();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const role = currentRole();
  const [open, setOpen] = useState(() => {
    const o = {};
    MENU.forEach((g) => g.items.forEach((it) => it.children?.some((c) => location.pathname.startsWith(c.to)) && (o[it.label] = true)));
    return o;
  });

  // 3 Kas: bekleyen odeme hesabi / cekim talebi varsa menude kirmizi sayi + sekme basliginda
  const [sayac, setSayac] = useState({});
  useEffect(() => {
    if (role !== "owner") return undefined;
    let kapali = false;
    const baslik = document.title.replace(/^\(\d+\) /, "");
    const cek = async () => {
      const r = await panelApi.payoutCounts().catch(() => null);
      if (kapali || !r?.status) return;
      setSayac(r);
      document.title = r.toplam > 0 ? `(${r.toplam}) ${baslik}` : baslik;
    };
    cek();
    const t = setInterval(cek, 60000);
    return () => {
      kapali = true;
      clearInterval(t);
    };
  }, [role, location.pathname]);
  const isaret = (it) =>
    it.badge && sayac[it.badge] > 0 ? (
      <b title="Bekleyen ödeme hesabı / çekim talebi" style={{ marginLeft: "auto", minWidth: 20, height: 20, padding: "0 6px", borderRadius: 10, background: "#FF3B30", color: "#fff", fontSize: 11, lineHeight: "20px", textAlign: "center", boxShadow: "0 0 0 3px rgba(255,59,48,.18)" }}>
        {sayac[it.badge]}
      </b>
    ) : null;

  const handleLogout = () => {
    warning()
      .then((logout) => {
        if (logout) {
          dispatch({ type: LOGOUT_ADMIN });
          history.push("/");
        }
      })
      .catch(() => {});
  };
  const giftClick = () => {
    sessionStorage.setItem("giftClick", true);
    sessionStorage.removeItem("GiftClick");
  };

  return (
    <div className="sidebar-wrapper sidebar-theme">
      <nav id="sidebar" className="badu-nav">
        <div className="badu-drawer-brand badu-brand-always">
          <img src={logo} alt="" />
          <div>
            <b>AYVO</b>
            <span>{ROLE_LABEL[role] || "Yönetim Paneli"}</span>
          </div>
        </div>
        <div className="badu-nav-scroll">
          {MENU.map((g) => {
            const items = g.items.filter((it) => canSee(role, it));
            if (!items.length) return null;
            return (
              <div key={g.group}>
                <div className="badu-grp">{t(g.group)}</div>
                {items.map((it) =>
                  it.children ? (
                    <div key={it.label}>
                      <button type="button" className={`badu-link ${open[it.label] ? "open" : ""}`} onClick={() => setOpen({ ...open, [it.label]: !open[it.label] })}>
                        {ic[it.icon]}
                        <span>{t(it.label)}</span>
                        <i className="badu-caret">›</i>
                      </button>
                      {open[it.label] && (
                        <div className="badu-sub">
                          {it.children.map((c) => (
                            <NavLink key={c.to} to={c.to} className="badu-sublink" activeClassName="active" onClick={c.gift ? giftClick : undefined}>
                              {t(c.label)}
                            </NavLink>
                          ))}
                        </div>
                      )}
                    </div>
                  ) : (
                    <NavLink key={it.to} to={it.to} className="badu-link" activeClassName="active">
                      {ic[it.icon]}
                      <span>{t(it.label)}</span>
                      {isaret(it)}
                    </NavLink>
                  )
                )}
              </div>
            );
          })}
          <button type="button" className="badu-link badu-logout" onClick={handleLogout}>
            {ic.logout}
            <span>Çıkış</span>
          </button>
        </div>
      </nav>
    </div>
  );
};

export default Sidebar;
